import { Badge, CardTitle, Typography } from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import React from 'react';
import { orderNumberFormat } from '../../shared/order-number-formatter/OrderNumberFormatter';
import { dateFormat } from '../../order-details/util/format';
import { monthDayYear } from '../../../constants/dateStrings';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
export var CardHeader = function (_a) {
    var _b;
    var orderNumber = _a.orderNumber, POJobName = _a.POJobName, projectName = _a.projectName, registerNumber = _a.registerNumber, salesDate = _a.salesDate, totalAmount = _a.totalAmount, transactionId = _a.transactionId, cpsDataSource = _a.cpsDataSource;
    var customerType = usePurchaseHistoryContext().customerType;
    return (React.createElement(React.Fragment, null,
        React.createElement(CardTitle, { disableTypography: true, header: React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-flex sui-gap-[8px]" },
                    POJobName && POJobName !== orderNumber && (React.createElement("div", null,
                        React.createElement(Badge, { variant: "regular", color: "info", style: {
                                fontSize: '12px',
                                marginBottom: '12px',
                                backgroundColor: '#E3F7F6',
                                padding: '0px 8px',
                            } }, POJobName))),
                    FeatureSwitches.enableProjectName &&
                        cpsDataSource === 'CPS' &&
                        projectName && (React.createElement("div", null,
                        React.createElement(Badge, { variant: "regular", color: "info", style: {
                                fontSize: '12px',
                                marginBottom: '12px',
                                backgroundColor: '#E3F7F6',
                                padding: '0px 8px',
                            } }, projectName)))),
                React.createElement(Typography, { weight: "bold", variant: "h3", height: "tight" }, orderNumberFormat(orderNumber, transactionId, registerNumber, true, customerType))), subheader: React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "body-lg", color: "subtle" },
                    salesDate
                        ? dateFormat(salesDate, monthDayYear)
                        : 'Date Unavailable',
                    ' ',
                    totalAmount !== null &&
                        totalAmount !== undefined &&
                        (totalAmount === null || totalAmount === void 0 ? void 0 : totalAmount.toFixed(2)) !== 'NaN' &&
                        "| Total: ".concat(totalAmount >= 0 ? '' : '-', "$").concat((_b = (totalAmount >= 0
                            ? totalAmount
                            : totalAmount * -1)) === null || _b === void 0 ? void 0 : _b.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }), " "))), action: React.createElement("div", { className: "sui-mt-[12px]" },
                React.createElement(ArrowForward, null)) })));
};
